import React from 'react';
import Emoji from "../../../icons/common/emoji/emoji";

type Props = {
    classes         : string
    emoji           : string
    onEmojiSelect   : callback
}

export default class EmojiItem extends React.Component<Props> {

    constructor(props: Props) {
        super(props);
    }

    onEmojiSelect = ()=> {
        this.props.onEmojiSelect(this.props.emoji)
    }

    render() {
        return (
            <div className={this.props.classes} onClick={this.onEmojiSelect}>
                <Emoji name={this.props.emoji} size="20" />
            </div>
        )
    }
}
